import { useQuery } from "@tanstack/react-query";
import { VoiceBackgroundsAPI } from "../api/voice-backgrounds";
import { useCurrentClient } from "@/features/clients/hooks/use-clients";

export const voiceBackgroundKeys = {
  all: ["voice-backgrounds"] as const,
  lists: () => [...voiceBackgroundKeys.all, "list"] as const,
  list: (clientId: string) =>
    [...voiceBackgroundKeys.lists(), clientId] as const,
};

export function useVoiceBackgrounds() {
  const currentClient = useCurrentClient();
  const clientId = currentClient?.client?.id || "";

  return useQuery({
    queryKey: voiceBackgroundKeys.list(clientId),
    queryFn: async () => {
      const data = await VoiceBackgroundsAPI.list(clientId);
      return data.backgrounds;
    },
    enabled: !!clientId,
  });
}
